import Mapper0 from "./mapper0.js";
import Mapper1 from "./mapper1.js";
import Mapper2 from "./mapper2.js";
import Mapper3 from "./mapper3.js";
import Mapper4 from "./mapper4.js";
import Mapper5 from "./mapper5.js";
import Mapper7 from "./mapper7.js";
import Mapper9 from "./mapper9.js";
import Mapper11 from "./mapper11.js";
import Mapper34 from "./mapper34.js";
import Mapper38 from "./mapper38.js";
import Mapper66 from "./mapper66.js";
import Mapper71 from "./mapper71.js";
import Mapper79 from "./mapper79.js";
import Mapper94 from "./mapper94.js";
import Mapper118 from "./mapper118.js";
import Mapper119 from "./mapper119.js";
import Mapper140 from "./mapper140.js";
import Mapper180 from "./mapper180.js";
import Mapper240 from "./mapper240.js";
import Mapper241 from "./mapper241.js";

export default {
  0: Mapper0,
  1: Mapper1,
  2: Mapper2,
  3: Mapper3,
  4: Mapper4,
  5: Mapper5,
  7: Mapper7,
  9: Mapper9,
  11: Mapper11,
  34: Mapper34,
  38: Mapper38,
  66: Mapper66,
  71: Mapper71,
  79: Mapper79,
  94: Mapper94,
  118: Mapper118,
  119: Mapper119,
  140: Mapper140,
  180: Mapper180,
  240: Mapper240,
  241: Mapper241,
};
